import React from 'react';
import { Routes, Route } from 'react-router-dom';
import './App.css';
import Navbar from './Components/Navbar/Navbar';
import Main from './Components/Main/Main';
import ContactForm from './Components/Contact/ContactForm';
import LegalNotice from './Components/LegalNotice/LegalNotice';
import Footer from './Components/Footer/Footer';
import AccessibilityWidget from './Components/Accessibility/AccessibilityWidget';

function App() {
  return (
    <div className="App">
      <a href="#main-content" className="skip-to-content">
        Aller au contenu principal
      </a>
      <Navbar />
      <div className="page-content">
        <Routes>
          <Route path="/" element={<Main />} />
          <Route path="/contact" element={<ContactForm />} />
          <Route path="/mentions-legales" element={<LegalNotice />} />
        </Routes>
      </div>
      <Footer />
      <AccessibilityWidget />
    </div>
  );
}

export default App;
